import { $getBoundaries } from "@/utils/endpoints";

export const state = () => ({
    boundaries: [],
    defaulCenter: 0,
    defaultZoom: 0
});

const getters = {
    boundaries: (state) => state.boundaries,
};

const mutations = {
    setBoundaries(state, boundaries) {
        state.boundaries = boundaries;
    }
}

const actions = {
    getBoundaries: async ({ commit }) => {
      const boundaries = await $getBoundaries();
      commit("setBoundaries", boundaries || []);
    }
}

const namespaced = true;

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced,
};
